import { render, staticRenderFns } from "./SaveInfo.vue?vue&type=template&id=af6ea666&scoped=true"
import script from "./SaveInfo.vue?vue&type=script&lang=js"
export * from "./SaveInfo.vue?vue&type=script&lang=js"
import style0 from "./SaveInfo.vue?vue&type=style&index=0&id=af6ea666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6ea666",
  null
  
)

export default component.exports